import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

// Shared display vocabulary for the Eligibility Administration surface. Extracted from the original
// read-only EligibilityPanel so the triage list, franchise rows, timeline, and dialogs render state
// and dates identically.
//
// TIMEZONE: enabled_from_date / enabled_through_date are DATE-only values, returned by the API as
// UTC-midnight ISO strings (e.g. "2025-09-13T00:00:00.000Z"). They must be formatted in UTC — using
// local time shifts the calendar day (one day early in negative-offset zones). reviewed_at/updated_at
// are real timestamps (datetimeoffset) and are shown in local time.

export const STATE_LABEL = {
  confirmed: "Confirmed",
  manual_review: "Manual Review",
  proposed: "Proposed",
  rejected: "Rejected",
  inactive: "Inactive",
  unconfigured: "Unconfigured / Fail Open",
};

export const STATE_COLOR = {
  confirmed: "success",
  manual_review: "warning",
  proposed: "info",
  rejected: "error",
  inactive: "default",
  unconfigured: "default",
};

export const fmtDate = (d) => (d ? dayjs.utc(d).format("MMM D, YYYY") : "—");

// The interval is stored HALF-OPEN [from, through), so the stored "through" is EXCLUSIVE.
// Administrators read "through" inclusively, so display through-1day. This also makes a
// single-day interval read correctly (e.g. Nov 28 -> Nov 28) instead of Nov 28 -> Nov 29.
export const fmtThroughInclusive = (d) =>
  d ? dayjs.utc(d).subtract(1, "day").format("MMM D, YYYY") : null;

// Real timestamp (reviewed_at / updated_at) — shown in local time.
export const fmtStamp = (d) => (d ? dayjs(d).format("MMM D, YYYY HH:mm") : "—");

// Date-input <-> stored-value conversion for the write dialogs, centralized here alongside the
// display formatters so the inclusive<->half-open boundary lives in ONE place. A native
// <input type="date"> uses 'YYYY-MM-DD'; all conversion is UTC-based to preserve the calendar day.
//
// Start Date maps straight to the stored enabled_from_date. End Date is shown/entered INCLUSIVELY
// (the last eligible day), while storage is half-open [from, through) — so the input shows
// through-1day, and submission adds it back.

// Stored date -> 'YYYY-MM-DD' for a date input; '' when absent.
export const toDateInput = (d) => (d ? dayjs.utc(d).format("YYYY-MM-DD") : "");

// Stored half-open enabled_through_date -> INCLUSIVE 'YYYY-MM-DD' for the End Date input; '' = open-ended.
export const toInclusiveInput = (through) =>
  through ? dayjs.utc(through).subtract(1, "day").format("YYYY-MM-DD") : "";

// Inclusive End Date input -> stored half-open enabled_through_date ('YYYY-MM-DD'); null = open-ended.
export const toStoredThrough = (inclusive) =>
  inclusive ? dayjs.utc(inclusive).add(1, "day").format("YYYY-MM-DD") : null;
